<ng-template #modalLG let-modal>
    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class="close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style="margin: 64px">
        <div class="modal-body p-0" tabindex="0" ngbAutofocus>
            <div class="text-center mb-2">
                <h5 style="font-size: 24px">Ajouter un fournisseur</h5>
                <p style="font-size: 15px" class="text-muted">Veuillez remplir tous ces champs nécessaires.</p>
            </div>
            <div class="center mb-2">
                <label class="form-label" for="nomEntreprise">Nom d'entreprise <span class="req" aria-required="true">*</span></label>
                <input
                        type="text"
                        class="form-control"
                        id="nomEntreprise"
                        placeholder="Entrez le nom de l'entreprise"
                        [(ngModel)]="fournisseur.nom_entreprise"
                name="nomEntreprise"
                required
                #nomEntrepriseControl="ngModel"
                aria-required="true"
                [ngClass]="{'is-invalid': nomEntrepriseControl.invalid && (nomEntrepriseControl.dirty || nomEntrepriseControl.touched)}"
                />
            </div>
            <div class="center mb-2">
                <label class="form-label" for="numeroIdentificationFiscale">Numéro d'identification fiscale <span class="req" aria-required="true">*</span></label>
                <div class="input-group">
                    <input
                            type="text"
                            class="form-control"
                            id="numeroIdentificationFiscale"
                            placeholder="Entrez l’identifiant"
                            [(ngModel)]="fournisseur.numero_identification_fiscale"
                            name="numeroIdentificationFiscale"
                            required
                            #numeroIdentificationFiscaleControl="ngModel"
                            aria-required="true"
                            [ngClass]="{'is-invalid': numeroIdentificationFiscaleControl.invalid && (numeroIdentificationFiscaleControl.dirty || numeroIdentificationFiscaleControl.touched)}"
                    />
                </div>
            </div>
            <div class="center mb-2">
                <label class="form-label">Civilité <span class="req" aria-required="true">*</span></label>
                <div class="d-flex align-items-center gap-4" [ngClass]="{'is-invalid': civiliteControl.invalid && (civiliteControl.dirty || civiliteControl.touched)}">
                    <label class="org-radio-option d-flex align-items-center gap-2" for="civilite_homme">
                        <div class="org-radio-wrapper" style="padding: 0;">
                            <input type="radio" name="civilite" id="civilite_homme" value="Homme" [(ngModel)]="fournisseur.civilite" required #civiliteControl="ngModel" aria-required="true" class="org-radio-input">
                            <span class="org-radio-label"><span class="org-radio-dot"></span></span>
                        </div>
                        <span class="form-label mb-0" style="font-size: 15px; margin: 0 22px 0 8px;">Homme</span>
                    </label>
                    <label class="org-radio-option d-flex align-items-center gap-2" for="civilite_femme">
                        <div class="org-radio-wrapper" style="padding: 0;">
                            <input type="radio" name="civilite" id="civilite_femme" value="Femme" [(ngModel)]="fournisseur.civilite" required aria-required="true" class="org-radio-input">
                            <span class="org-radio-label"><span class="org-radio-dot"></span></span>
                        </div>
                        <span class="form-label mb-0" style="font-size: 15px; margin-left: 8px;">Femme</span>
                    </label>
                </div>
            </div>
            <div class="center mb-2">
                <label class="form-label" for="contactName">Nom du contact <span class="req" aria-required="true">*</span></label>
                <div class="input-group">
                    <input
                            type="text"
                            class="form-control"
                            id="contactName"
                            placeholder="Entrez le nom du contact"
                            [(ngModel)]="fournisseur.identifiant_unique"
                            name="contactName"
                            required
                            #contactNameControl="ngModel"
                            aria-required="true"
                            [ngClass]="{'is-invalid': contactNameControl.invalid && (contactNameControl.dirty || contactNameControl.touched)}"
                    />
                </div>
            </div>
        </div>
        <div class="centerButtons">
            <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!isFormValid" rippleEffect>
                Valider
            </button>
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" rippleEffect>Annuler</button>
        </div>
    </div>
</ng-template>
